import type { ReactElement } from 'react'
import useLayout from '../../../hooks/useLayout'
import { StyledDrawer, drawerPaperSx } from './styles'

interface Props {
  children: ReactElement
}

export function DesktopDrawer({ children }: Props) {
  const { isSidebarOpen } = useLayout()

  return (
    <StyledDrawer
      anchor='left'
      variant='permanent'
      open={isSidebarOpen}
      slotProps={{ paper: { sx: drawerPaperSx } }}
    >
      {children}
    </StyledDrawer>
  )
}
